<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4>Danh sách bảng lương</h4>
          </div>
          <div class="text-right"></div>
        </div>
        <div class="main-body mt-3">
          <el-table :data="mData.tableRules.data" border style="width: 100%">
            <el-table-column prop="" label="STT" width="50">
              <template slot-scope="scope">
                <div class="text-center">
                  {{ mData.tableRules.offset + scope.$index + 1 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="salary_period_name"
              label="Kỳ lương"
              min-width="280"
            ></el-table-column>
            <el-table-column
              prop="from_date"
              label="Thời gian từ"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="to_date"
              label="Thời gian tới"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="total_work"
              label="Tổng công"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="total_income"
              label="Tổng lương"
              width="150"
              align="center"
            >
              <template slot-scope="scope">
                <div class="d-flex1" v-if="!dataShowHide[scope.$index].hideTotalIncome">
                  <p>{{ fn_formatCurrency(scope.row.total_income) }}</p>
                  <i
                    style="cursor: pointer"
                    class="isax__icon isax-eye ml-3"
                    @click="fn_showHideTotalIncome('hide', scope.$index)"
                  ></i>
                </div>
                <div class="d-flex1" v-if="dataShowHide[scope.$index].hideTotalIncome">
                  <p>********</p>
                  <i
                    style="cursor: pointer"
                    class="isax__icon isax-eye-slash ml-3"
                    @click="fn_showHideTotalIncome('show', scope.$index)"
                  >
                  </i>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Thao tác"
              align="center"
              width="80"
              v-if="mData.dataDefault.listFeature.includes('FT1202')"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  plain
                  round
                  @click="fn_handle('detail', scope.row)"
                  v-b-popover.hover.left="'Chi tiết'"
                  v-if="mData.dataDefault.listFeature.includes('FT1202')"
                >
                  <i class="fa fa-eye"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- dialog xem chi tiết file  -->
    <el-dialog
      :title="`Chi tiết bảng lương ${getNamePeriod(currentPeriodView)}`"
      :visible.sync="dialogShowDataDetail"
      width="40%"
      top="80px"
      height="440"
      custom-class="salary-detail-dialog"
      :before-close="closeDialogShowDataDetail"
    >
      <div class="salary-detail-wrapper">
        <table class="salary-detail-table">
          <tbody>
            <template v-for="section in detailSections">
              <tr v-for="(item, index) in section.rows" :key="`${section.key}-${index}`">
                <td v-if="index === 0" :rowspan="section.rows.length" class="salary-detail-group">
                  {{ section.label }}
                </td>
                <td class="salary-detail-label">{{ item.label }}</td>
                <td class="salary-detail-value">{{ fn_formatDetailValue(item.value) }}</td>
              </tr>
              <tr v-for="summary in section.summaries" :key="`${section.key}-${summary.label}`">
                <td colspan="2" class="salary-detail-summary">{{ summary.label }}</td>
                <td class="salary-detail-value">{{ fn_formatDetailValue(summary.value) }}</td>
              </tr>
            </template>
            <tr v-for="summary in detailFooterRows" :key="summary.label">
              <td colspan="2" class="salary-detail-summary">{{ summary.label }}</td>
              <td class="salary-detail-value">{{ fn_formatDetailValue(summary.value) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MethodService from "../../../../service/MethodService";
import LanguageService from "../../../../service/LanguageService";
import SalaryApi from "../../../../moduleApi/SalaryApi";
import TaxApi from "../../../../moduleApi/TaxApi";
import InsuranceApi from "../../../../moduleApi/InsuranceApi";
import SalaryPeriodApi from "../../../../moduleApi/SalaryPeriodApi";
import WorkApi from "../../../../moduleApi/WorkApi";
import DepartmentApi from "../../../../moduleApi/DepartmentApi";
import PositionApi from "../../../../moduleApi/PositionApi";
import SalaryEmployeeModel from "./SalaryEmployeeModel";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aElement: MethodService.element,
      aLang: LanguageService.lang,
      dataShowHide: [],
      dialogShowDataDetail: false,
      tabShow: 'Salary',
      currentPeriodView: undefined,
      currentSalaryDetail: {},
      mData: {
        id: null,
        viewMode: "create",
        moduleName: "SalaryEmployee", //requied
        tableRules: MethodService.copyObject(SalaryEmployeeModel.tableRules),
        dataForm: {
          company_id: undefined,
          is_approved: undefined,
        },
        dataDefault: {
          listCompany: [],
          listSalaryPeriod: [],
          listWork: [],
          listFeature: MethodService.getListFeatures(),
          currentUser: MethodService.getCurrentUser(),
          userProfile: MethodService.getUserProfile(),
          employeeInfo: MethodService.getEmployeeInfo(),
          employeePayrollInfo: {},
        },
        dataExcelHeader: [],
        dataExcel: [],
        dataTableTax: [],
        dataTableInsurance: []
      },
    };
  },

  computed: {
    detailSections() {
      return [
        {
          key: "employee",
          label: "Thông tin nhân viên",
          rows: this.getDetailRows("employee"),
          summaries: []
        },
        {
          key: "work",
          label: "Thông tin chấm công",
          rows: this.getDetailRows("work"),
          summaries: [
            { label: "Lương cơ bản", value: this.getSalaryDetailValue(["salary_level", "gross_salary", "Lương cơ bản", "Mức lương", "Basic salary"]) }
          ]
        },
        {
          key: "income",
          label: "Chi tiết thu nhập",
          rows: this.getDetailRows("income"),
          summaries: [
            { label: "Tổng thu nhập", value: this.totalIncomeDetail }
          ]
        },
        {
          key: "deduction",
          label: "Các khoản khấu trừ",
          rows: this.getDetailRows("deduction"),
          summaries: []
        }
      ];
    },
    detailFooterRows() {
      return [
        { label: "Tổng khấu trừ", value: this.totalDeductionDetail },
        { label: "Tổng lương thực lĩnh", value: this.getUploadedTotalIncomeDetailValue() }
      ];
    },
    totalIncomeDetail() {
      const explicitValue = this.getSalaryDetailValue(["total_gross_income", "gross_income", "income_total", "Tổng thu nhập"]);
      if (explicitValue !== "") return explicitValue;
      const total = this.getDetailRows("income").reduce((result, item) => result + this.getNumberDetailValue(item.value), 0);
      return total ? total : "";
    },
    totalDeductionDetail() {
      return this.getDetailRows("deduction").reduce((total, item) => total + this.getNumberDetailValue(item.value), 0);
    }
  },

  methods: {
    async initDataSalary() {
      const salaryApires = await SalaryApi.list({
        filters: `employee_id=${this.mData.dataDefault.currentUser.id}&sealed=true`,
        sort: '-salary_period_id',
      });
      if (salaryApires.result && salaryApires.result.length > 0) {
        let resData = await this.fn_changeData(salaryApires.result);
        this.mData.tableRules.data = resData;
      }
    },
    async fn_changeData(resData) {
      let salaryPeriodIds = [];
      salaryPeriodIds = MethodService.findListItemDifferent(resData, "salary_period_id");
      const salaryPeriodApiReq = await SalaryPeriodApi.list({
        limit: salaryPeriodIds.length,
        filters: "id:in:" + salaryPeriodIds.join(","),
      });
      const workApiReq = await WorkApi.list({
        limit: 100000000,
        filters:
          "employee_id=" +
          this.mData.dataDefault.currentUser.id +
          "&salary_period_id:in:" +
          salaryPeriodIds.join(","),
      });

      const salaryPeriodApiRes = await salaryPeriodApiReq;
      const workApiRes = await workApiReq;

      this.mData.dataDefault.listSalaryPeriod = salaryPeriodApiRes.result;
      this.mData.dataDefault.listWork = workApiRes.result;

      resData.forEach((item, index) => {
        let salaryPeriod = this.mData.dataDefault.listSalaryPeriod.find((e) => {
          return e.id == item.salary_period_id;
        });
        let work = this.mData.dataDefault.listWork.filter((element) => {
          return (
            element.employee_id == item.employee_id &&
            element.salary_period_id == item.salary_period_id
          );
        });
        if (salaryPeriod && salaryPeriod.name) {
          item.salary_period_name = salaryPeriod.name;
        } else {
          item.salary_period_name = "";
        }
        if (salaryPeriod && salaryPeriod.from_date) {
          item.from_date = this.fn_formatDate(salaryPeriod.from_date);
        } else {
          item.from_date = "";
        }
        if (salaryPeriod && salaryPeriod.before_to_date) {
          item.to_date = this.fn_formatDate(
            new Date(
              new Date(salaryPeriod.before_to_date).valueOf() - 1000 * 60 * 60 * 24
            )
          );
        } else {
          item.to_date = "";
        }

        if (work.length == 0) {
          item.total_work = 0;
        } else {
          item.total_work = 0;
          work.forEach((w) => {
            item.total_work += w.work_value;
          });
        }
        if (item.total_work) {
          item.total_work = Math.round(item.total_work * 100) / 100;
        }
        this.dataShowHide.push({ hideTotalIncome: true });
      });
      return resData;
    },
    async getSalary(salaryPeriodId) {
      const salaryApiRes = await SalaryApi.list({
        filters: `salary_period_id=${salaryPeriodId}&employee_id=$$user_id`
      })
      const salary = salaryApiRes.result[0]
      if (!salary) return
      this.currentSalaryDetail = salary
      this.mData.dataExcel = salary.custom_fields || []
      await this.loadCompanyPayrollDetail(salary)
    },
    async getTax(salaryPeriodId) {
      this.mData.dataTableTax = []
      const taxApiRes = await TaxApi.list({
        filters: `salary_period_id=${salaryPeriodId}&employee_id=$$user_id`
      })
      for (const property in taxApiRes.result[0]) {
        let obj = {}
        if (
          property == 'income_tax' ||
          property == 'family_allowances' ||
          property == 'donate' ||
          property == 'compulsory_insurance' ||
          property == 'taxable_income' ||
          property == 'reduction_rate'
        ) {
          obj.key =
            property == 'income_tax' ? 'Thu nhập chịu thuế' :
            property == 'family_allowances' ? 'Giảm trừ gia cảnh' :
            property == 'donate' ? 'Ủng hộ' :
            property == 'compulsory_insurance' ? 'Bảo hiểm bắt buộc' :
            property == 'taxable_income' ? 'Thu nhập tính thuế' :
            property == 'reduction_rate' ? 'Tỷ lệ giảm thuế TNCN do có TN tại khu kinh tế' : ''
          obj.value = taxApiRes.result[0][property]
          this.mData.dataTableTax.push(obj)
        }
      }
    },
    async getInsurance(salaryPeriodId) {
      this.mData.dataTableInsurance = []
      const insuranceApiRes = await InsuranceApi.list({
        filters: `salary_period_id=${salaryPeriodId}&employee_id=$$user_id`
      })
      if (insuranceApiRes.result[0]) {
        let total =
          parseInt(insuranceApiRes.result[0].social_insurance) +
          parseInt(insuranceApiRes.result[0].health_insurance) +
          parseInt(insuranceApiRes.result[0].unemployment_insurance)
        insuranceApiRes.result[0].total = total
      }
      for (const property in insuranceApiRes.result[0]) {
        let obj = {}
        if (
          property == 'social_insurance' ||
          property == 'health_insurance' ||
          property == 'unemployment_insurance' ||
          property == 'total'
        ) {
          obj.key =
            property == 'social_insurance' ? 'Bảo hiểm xã hội' :
            property == 'health_insurance' ? 'Bảo hiểm y tế' :
            property == 'unemployment_insurance' ? 'Bảo hiểm thất nghiệp' :
            property == 'total' ? 'Tổng' : ''
          obj.value = insuranceApiRes.result[0][property]
          this.mData.dataTableInsurance.push(obj)
        }
      }
    },
    async fn_handle(type, row) {
      if (type == "detail") {
        this.currentPeriodView = row.salary_period_id
        this.currentSalaryDetail = row

        this.getTax(row.salary_period_id)
        this.getInsurance(row.salary_period_id)
        this.mData.dataExcel = row.custom_fields
        this.dialogShowDataDetail = true
        await this.loadCompanyPayrollDetail(row)
      }
    },
    closeDialogShowDataDetail() {
      this.dialogShowDataDetail = false;
      this.mData.dataExcel = [];
      this.mData.dataExcelHeader = [];
      this.tabShow = 'Salary'
      this.currentSalaryDetail = {};
    },
    fn_showHideTotalIncome(type, index) {
      if (type == "hide") {
        this.dataShowHide[index].hideTotalIncome = true;
      } else if (type == "show") {
        this.dataShowHide[index].hideTotalIncome = false;
      }
    },
    fn_formatCurrency(value) {
      return MethodService.formatCurrency(value);
    },
    fn_formatDetailValue(value) {
      if (value === undefined || value === null || value === "") return "";
      return value && !isNaN(value) && value > 1000
        ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : value;
    },
    getNumberDetailValue(value) {
      if (value === undefined || value === null || value === "") return 0;
      const numberValue = Number(value.toString().replace(/,/g, ""));
      return isNaN(numberValue) ? 0 : numberValue;
    },
    getTableDetailValue(table, labels) {
      const fields = Array.isArray(table) ? table : [];
      const aliases = labels.map((label) => this.normalizeDetailKey(label));
      const item = fields.find((field) => {
        const key = this.normalizeDetailKey(field.key);
        const label = this.normalizeDetailKey(field.label);
        return aliases.some((alias) => alias && (
          (key && (key === alias || key.includes(alias) || alias.includes(key))) ||
          (label && (label === alias || label.includes(alias) || alias.includes(label)))
        ));
      });
      return item && item.value !== undefined && item.value !== null ? item.value : "";
    },
    getSalaryDetailValue(labels) {
      const fieldValue = this.getTableDetailValue(this.mData.dataExcel, labels);
      if (fieldValue !== "") return fieldValue;
      return this.getFirstObjectValue(this.currentSalaryDetail, labels);
    },
    getCompanyPayrollDetailValue(code, labels = [], fallbackValue = "") {
      const calculatedValue = this.getFirstObjectValue(this.currentSalaryDetail, [
        code,
        `payroll_snapshot.${code}`
      ]);
      if (calculatedValue !== "") return calculatedValue;
      if (fallbackValue !== undefined && fallbackValue !== null && fallbackValue !== "") {
        return fallbackValue;
      }
      return this.getTableDetailValue(this.mData.dataExcel, [code, ...labels]);
    },
    getUploadedTotalIncomeDetailValue() {
      const uploadedValue = this.getFirstObjectValue(this.currentSalaryDetail, [
        "uploaded_total_income"
      ]);
      if (uploadedValue !== "") return uploadedValue;

      const customFieldValue = this.getTableDetailValue(this.mData.dataExcel, [
        "total_income",
        "Tổng lương thực nhận",
        "Tổng lương thực nhận (*)",
        "Tổng lương thực lĩnh"
      ]);
      if (customFieldValue !== "") return customFieldValue;

      return this.getCompanyPayrollDetailValue("total_income", [
        "Tổng lương thực nhận",
        "Tổng lương thực nhận (*)",
        "Tổng lương thực lĩnh"
      ]);
    },
    getTaxDetailValue(labels) {
      return this.getTableDetailValue(this.mData.dataTableTax, labels);
    },
    getInsuranceDetailValue(labels) {
      return this.getTableDetailValue(this.mData.dataTableInsurance, labels);
    },
    getEmployeeDetailValue(paths) {
      const sources = [
        this.currentSalaryDetail,
        this.mData.dataDefault.employeePayrollInfo,
        this.mData.dataDefault.employeeInfo,
        this.mData.dataDefault.userProfile
      ];
      for (const source of sources) {
        const value = this.getFirstObjectValue(source, paths);
        if (value !== "") return value;
      }
      return "";
    },
    async loadEmployeePayrollInfo() {
      const employee = this.mData.dataDefault.employeeInfo || {};
      const jobInfos = Array.isArray(employee.job_info) ? employee.job_info : [];
      const jobInfo = jobInfos.length ? jobInfos[jobInfos.length - 1] : {};
      let departmentName = jobInfo.department_name || "";
      let positionName = jobInfo.position_name || "";

      const departmentRequest = !departmentName && jobInfo.department_id
        ? DepartmentApi.findById(jobInfo.department_id)
        : Promise.resolve(null);
      const positionRequest = !positionName && jobInfo.position_id
        ? PositionApi.findById(jobInfo.position_id)
        : Promise.resolve(null);

      try {
        const [departmentResponse, positionResponse] = await Promise.all([
          departmentRequest,
          positionRequest
        ]);
        departmentName = departmentName || this.getObjectValue(departmentResponse, "result.name");
        positionName = positionName || this.getObjectValue(positionResponse, "result.name");
      } catch (error) {
        // Giữ giá trị có sẵn trong hồ sơ nếu danh mục không tải được.
      }

      this.mData.dataDefault.employeePayrollInfo = {
        department_name: departmentName,
        position_name: positionName,
        dependent_person: Array.isArray(employee.dependent_person_info)
          ? employee.dependent_person_info.length
          : 0
      };
    },
    getFirstObjectValue(source, paths) {
      const path = paths.find((item) => this.getObjectValue(source, item) !== "");
      return path ? this.getObjectValue(source, path) : "";
    },
    getObjectValue(source, path) {
      if (!source || !path) return "";
      const value = path.split(".").reduce((result, key) => {
        return result && result[key] !== undefined ? result[key] : undefined;
      }, source);
      return value === undefined || value === null ? "" : value;
    },
    normalizeDetailKey(value) {
      return MethodService.changeAlias(`${value || ""}`)
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
    },
    getOtDetailValue() {
      const explicitValue = this.getSalaryDetailValue(["ot_hour", "Số giờ OT", "Số giờ làm thêm"]);
      if (explicitValue !== "") return explicitValue;
      const ot150 = this.getSalaryDetailValue(["ot_150", "Số giờ làm thêm 150%"]);
      const ot200 = this.getSalaryDetailValue(["ot_200", "Số giờ làm thêm 200%"]);
      const ot300 = this.getSalaryDetailValue(["ot_300", "Số giờ làm thêm 300%"]);
      const total = [ot150, ot200, ot300].reduce((result, value) => result + this.getNumberDetailValue(value), 0);
      return [ot150, ot200, ot300].some((value) => value !== "") ? total : "";
    },
    async loadCompanyPayrollDetail(salary) {
      if (!salary || !salary.salary_period_id) return;
      try {
        const payrollResponse = await SalaryApi.GetCompanyPayroll({
          salary_period_id: salary.salary_period_id,
          company_id: salary.company_id,
          condition: salary.employee_no || ""
        });
        const payrollRows = this.getObjectValue(payrollResponse, "result.rows") || [];
        const payrollRow = payrollRows.find((item) =>
          item.employee_id === salary.employee_id ||
          (salary.employee_no && item.employee_no === salary.employee_no)
        );
        if (payrollRow) {
          this.currentSalaryDetail = {
            ...salary,
            ...payrollRow,
            uploaded_total_income: salary.total_income,
            custom_fields: salary.custom_fields || []
          };
        }
      } catch (error) {
        // Các dữ liệu có sẵn từ file upload vẫn được hiển thị khi API tính lương lỗi.
      }
    },
    getDetailRows(type) {
      const rows = {
        employee: [
          { label: "Mã nhân viên", value: this.getEmployeeDetailValue(["employee_no"]) },
          { label: "Họ và tên", value: this.getEmployeeDetailValue(["employee_name", "full_name", "name.full_name", "administrative_info.name.full_name"]) },
          { label: "Phòng ban", value: this.getEmployeeDetailValue(["department_name", "department.name", "work_info.department_name"]) },
          { label: "Chức vụ", value: this.getEmployeeDetailValue(["position_name", "position.name", "work_info.position_name"]) },
          { label: "Số người phụ thuộc", value: this.getTableDetailValue(this.mData.dataExcel, ["dependent_person", "Số người phụ thuộc"]) !== ""
            ? this.getTableDetailValue(this.mData.dataExcel, ["dependent_person", "Số người phụ thuộc"])
            : this.getEmployeeDetailValue(["payroll_snapshot.dependent_person", "dependent_person"]) }
        ],
        work: [
          { label: "Ngày công chuẩn", value: this.getSalaryDetailValue(["standard_work", "Ngày công chuẩn", "Ngày công trong tháng", "Ngày công"]) },
          { label: "Số công làm việc thực tế", value: this.getSalaryDetailValue(["actual_work", "Số công làm việc thực tế"]) !== ""
            ? this.getSalaryDetailValue(["actual_work", "Số công làm việc thực tế"])
            : this.currentSalaryDetail.total_work },
          { label: "Số giờ OT", value: this.getOtDetailValue() },
          { label: "Nghỉ phép có lương", value: this.getSalaryDetailValue(["paid_leave", "Nghỉ phép có lương"]) },
          { label: "Nghỉ không lương", value: this.getSalaryDetailValue(["unpaid_leave", "Nghỉ không lương"]) }
        ],
        income: [
          { label: "Lương thực tế", value: this.getCompanyPayrollDetailValue("salary_income", ["Lương", "Lương cơ bản"]) },
          { label: "OT", value: this.getCompanyPayrollDetailValue("ot_income", ["OT", "Tiền OT", "Lương OT"]) },
          { label: "Phụ cấp", value: this.getCompanyPayrollDetailValue("meal_allowance", ["Phụ cấp", "Phụ cấp ăn trưa", "Tiền ăn", "Ăn trưa"]) },
          { label: "Thưởng", value: this.getCompanyPayrollDetailValue("bonus", ["Thưởng", "Thưởng tháng", "Bonus"]) }
        ],
        deduction: [
          { label: "BHXH", value: this.getCompanyPayrollDetailValue("social_insurance", ["Bảo hiểm xã hội", "BHXH"], this.getInsuranceDetailValue(["Bảo hiểm xã hội", "BHXH"])) },
          { label: "BHYT", value: this.getCompanyPayrollDetailValue("health_insurance", ["Bảo hiểm y tế", "BHYT"], this.getInsuranceDetailValue(["Bảo hiểm y tế", "BHYT"])) },
          { label: "BHTN", value: this.getCompanyPayrollDetailValue("unemployment_insurance", ["Bảo hiểm thất nghiệp", "BHTN"], this.getInsuranceDetailValue(["Bảo hiểm thất nghiệp", "BHTN"])) },
          { label: "Thuế TNCN", value: this.getCompanyPayrollDetailValue("tax_amount", ["Thuế TNCN", "Thuế thu nhập cá nhân"], this.getTaxDetailValue(["Thuế TNCN", "Thu nhập chịu thuế"])) },
          { label: "Khấu trừ tiền ăn", value: this.getCompanyPayrollDetailValue("meal_deduction", ["Khấu trừ tiền ăn"]) },
          { label: "Tạm ứng", value: this.getCompanyPayrollDetailValue("advance_amount", ["Tạm ứng", "Advance"]) },
          { label: "Khoản giảm trừ khác", value: this.getCompanyPayrollDetailValue("reduction_other", ["Khoản giảm trừ khác", "Khác", "Khoản khác"]) }
        ]
      };
      return rows[type] || [];
    },
    fn_formatDate(value) {
      return MethodService.formatDate(value, "date");
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    getNamePeriod(periodId) {
      let period = this.mData.dataDefault.listSalaryPeriod.find(item => item.id == periodId)
      if (!period) return ''
      return period.name.toLowerCase()
    },
    fn_hashUrl() {
      if (this.$route.query.tab) this.tabShow = this.$route.query.tab
      if (this.$route.query.salary_period_id) {
        this.currentPeriodView = this.$route.query.salary_period_id
        this.getSalary(this.$route.query.salary_period_id)
        this.getTax(this.$route.query.salary_period_id)
        this.getInsurance(this.$route.query.salary_period_id)
        this.dialogShowDataDetail = true
      }
    },
  },

  //run after render view
  created() {
    this.fn_hashUrl()
    this.initDataSalary()
    this.loadEmployeePayrollInfo()
  },
}
</script>

<style scoped lang="scss">
.d-flex {
  flex-direction: column;
}
.d-flex1 {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}
::v-deep .el-tabs--card > .el-tabs__header {
  margin-bottom: 0;
  margin-left: 25px;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #c8ced3;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-right: 25px;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}
::v-deep .salary-detail-dialog .el-dialog__body {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}
.salary-detail-wrapper {
  overflow-x: auto;
}
.salary-detail-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  color: #1f2d3d;
}
.salary-detail-table td {
  border: 1px solid #1f1f1f;
  height: 42px;
  padding: 8px 12px;
  vertical-align: middle;
  word-break: break-word;
}
.salary-detail-group {
  width: 110px;
  font-size: 16px;
  line-height: 20px;
}
.salary-detail-label {
  width: 280px;
  font-size: 16px;
}
.salary-detail-value {
  font-size: 15px;
}
.salary-detail-summary {
  font-size: 16px;
  text-align: center;
}
</style>
